export default "__VITE_ASSET__4xOzuwZw__"